import React from 'react'
import Header from '../../Components/Header/Header'
import BannerGlobal from '../../Components/Banner/BannerGlobal'
import Footer from '../../Components/Footer/Footer'
import BlogDetailsCompo from '../../Components/BlogComponent/BlogDetailsCompo'
import ContactComponent from '../../Components/ContactComponent/ContactComponent'
import useDocumentTitle from '../../PageTitle'

const BlogDetails = () => {
  useDocumentTitle("Medical | Blog Details")
  return (
    <div>
        <Header/>
        <BannerGlobal/>
        <BlogDetailsCompo/>
        <ContactComponent/>
        <Footer/>
    </div>
  )
}

export default BlogDetails